// extracted by mini-css-extract-plugin
module.exports = {"terms":"Qq2qjdDNlcTf5fLNFFMZ"};